import { useEffect, useState } from "react";
import { Steps, Card, Button, Form, Space } from "antd";
import {
  EditOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { UserStep } from "./components/UsersStep/UserStep";
import { WorksStep } from "./components/WorksStep/WorksStep";
import { TitleProjectStep } from "./components/TitleProjectStep/TitleProjectStep";
import { CheckEndStep } from "./components/CheckEndStep/CheckEndStep";
import { useDispatch, useSelector } from "react-redux";
import {
  createProjectThunk,
  selectProject,
  setAllowedWorkType,
  setChangeAccountNumber,
  setChangeGroup,
  setChangePlannedValue,
  setChangeUsers,
  setCreateGroup,
  setDeleteAllowedWork,
  setDeleteGroup,
  setTitle,
} from "AppStore/Slices/ProjectSlice/ProjectSlice";
import {
  getAllRolesThunk,
  selectUser,
} from "AppStore/Slices/UserSlice/UserSlice";
import { useNavigate } from "react-router";

const steps = [
  {
    title: "Назва проекту",
    icon: <EditOutlined />,
  },
  {
    title: "Роботи",
    icon: <MenuUnfoldOutlined />,
  },
  {
    title: "Користувачі",
    icon: <TeamOutlined />,
  },
  {
    title: "Завершення",
    icon: <CheckCircleOutlined />,
  },
];

export default function CreateProjectPage() {
  const { title, projectGroups, workTypes, users, accountNumber } =
    useSelector(selectProject);

  const { allRoles } = useSelector(selectUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const changeParams = (param, value) => {
    switch (param) {
      case "title":
        dispatch(setTitle(value));
        break;
      case "groupCreate":
        dispatch(setCreateGroup(value));
        break;
      case "deleteGroup":
        dispatch(setDeleteGroup(value));
        break;
      case "deleteAllowedWorkTypes":
        dispatch(setDeleteAllowedWork(value));
        break;
      case "changePlannedValue":
        dispatch(setChangePlannedValue(value));
        break;
      case "addAllowedWorkType":
        dispatch(setAllowedWorkType(value));
        break;
      case "changeGroup":
        dispatch(setChangeGroup(value));
        break;
      case "changeUsers":
        dispatch(setChangeUsers(value));
        break;
      case "accountNumber":
        dispatch(setChangeAccountNumber(value));
        break;
      default:
        break;
    }
  };
  const [current, setCurrent] = useState(0);
  const [form] = Form.useForm();
  const next = () => {
    try {
      setCurrent((s) => s + 1);
    } catch (e) {
      // якщо помилка — то ми залишаємося на кроці, далі обробка не йде
    }
  };

  const prev = () => setCurrent((s) => s - 1);

  useEffect(() => {
    dispatch(getAllRolesThunk());
  }, []);
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div>
        <Steps current={current} items={steps} style={{ marginBottom: 24 }} />

        <Card style={{ borderRadius: 16 }}>
          <Form layout="vertical" form={form}>
            {current === 0 && (
              <TitleProjectStep
                value={title}
                onChange={changeParams}
                accountNumber={accountNumber}
              />
            )}

            {current === 1 && (
              <WorksStep
                onChange={changeParams}
                groups={projectGroups}
                selectedWorks={workTypes}
              />
            )}

            {current === 2 && (
              <UserStep
                users={users}
                onChange={(params) => changeParams("changeUsers", params)}
                roles={allRoles}
              />
            )}

            {current === 3 && (
              <CheckEndStep
                projectTitle={title}
                projectUsers={users}
                projectWorks={workTypes}
              />
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 24,
              }}
            >
              <Space>
                {current > 0 && <Button onClick={prev}>Назад</Button>}
              </Space>

              <Space>
                {current < steps.length - 1 && (
                  <Button type="primary" onClick={next}>
                    Далі
                  </Button>
                )}

                {current === steps.length - 1 && (
                  <Button
                    type="primary"
                    onClick={() => {
                      dispatch(createProjectThunk());
                      navigate("/");
                    }}
                  >
                    Створити
                  </Button>
                )}
              </Space>
            </div>
          </Form>
        </Card>
      </div>
    </div>
  );
}
